import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import CurrentTestVue from '../views/CurrentTest.vue'
import LogoutVue from '../views/Logout.vue'
import store from '../store/index'
import routes, { ExtendedRoute } from './routes'

Vue.use(VueRouter)

const hardRoutes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/inscription',
    name: 'Register',
    component: () => import('../views/Register.vue'),
    display: false,
  },
  {
    path: '/account',
    name: 'Account',
    component: () => import('../views/Account.vue'),
    display: false,
  },
  {
    path: '/password/reset/:token',
    name: 'PasswordReset',
    component: () => import('../views/password-reset/PasswordReset.vue'),
    props: (route) => ({ token: route.params.token }),
    display: false,
  },
  {
    path: '/forgotten-password',
    name: 'RequestPasswordReset',
    component: () => import('../views/password-reset/RequestPasswordReset.vue'),
    display: false,
  },
  {
    path: '/account/trigger-activation',
    name: 'trigger-activation',
    component: () => import('../views/account-activation/AccountTriggerActivationMail.vue'),
    props: true,
    display: false,
  },
  {
    path: '/account/activation/:token',
    name: 'account-activation',
    component: () => import('../views/account-activation/AccountActivation.vue'),
    props: (route) => ({ token: route.params.token }),
    display: false,
  },
  {
    path: '/NotFoundError',
    name: 'NotFoundError',
    component: () => import('../views/NotFoundError.vue'),
  },

  // pour test e2e
  {
    path: '/current-test',
    name: 'CurrentTest',
    component: CurrentTestVue,
  },
  {
    path: '/logout',
    name: 'logout',
    component: LogoutVue,
  },

  {
    path: '*',
    redirect: '/NotFoundError',
  },
] as ExtendedRoute[]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routes.concat(hardRoutes),
})

router.beforeEach((to, from, next) => {
  const noAuthRequired = ['Signature Terminée']
  if (to.name !== 'Login' && to.name !== 'CurrentTest' && to.name !== 'Register' && !to.name?.includes('Password') && !store.state.authenticated && to.name !== 'trigger-activation' && to.name !== 'account-activation'
    && !noAuthRequired.includes(to.name as string)
  ) {
    next({ path: '/login', query: { redirect: to.fullPath } })
  } else if ((to.name === 'Login' || to.name === 'Register' || to.name?.includes('Password') || to.name === 'trigger-activation' || to.name === 'account-activation') && store.state.authenticated && !to.query.token) {
    next({ path: '/' })
  } else {
    next()
  }
})

export default router
